import { css, type Theme } from "@emotion/react";

export const dropdownItem = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const backorderedIcon = (theme: Theme) => css`
  &&& path {
    color: ${theme.warning.textBase};
  }
`;

export const outOfStockIcon = (theme: Theme) => css`
  &&& path {
    color: ${theme.danger.textBase};
  }
`;
